import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import Button from 'components/theme/Button'
import { clickCodeButton } from 'actions/template'
import classNames from 'classnames'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import language from 'utils/vast-languagepack'

export default connect(
  (state) => ({
    codeEditorDisplayed: state.email.codeEditorDisplayed,
    buttonVisible:
      typeof state.email.sectionSelected === 'number' &&
      state.email.sections[state.email.sectionSelected] &&
      state.email.sections[state.email.sectionSelected].editor === 'wysiwyg',
  }),
  (dispatch) => bindActionCreators({ clickCodeButton }, dispatch)
)(
  withStyles(styles)(
    ({ clickCodeButton, codeEditorDisplayed, classes, size, buttonVisible }) =>
      buttonVisible ? (
        <Button
          className={classNames(classes.button, 'ignore-react-onclickoutside')}
          variant='contained'
          color='secondary'
          onClick={(e) => {
            e.stopPropagation();
            clickCodeButton();
          }}
          size={size}
        >
          {codeEditorDisplayed ? (
            <KeyboardArrowLeftIcon
              className={classNames(classes.leftIcon, classes.iconSmall)}
            />
          ) : null}
          {codeEditorDisplayed
            ? language.templatePage.templateFormPage.editCodeDetails
            : language.templatePage.templateFormPage.editCode}
        </Button>
      ) : null
  )
);
